module.exports = __webpack_public_path__ + "img/samplering.40e1737.jpg";